var _excluded = ["root", "children", "buildKey"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import useForceUpdate from "../../hooks/useForceUpdate";
import { jsx as _jsx } from "react/jsx-runtime";
var TreeBuilder = function TreeBuilder(NodeComponent) {
  return function (_ref) {
    var root = _ref.root,
      children = _ref.children,
      _ref$buildKey = _ref.buildKey,
      buildKey = _ref$buildKey === void 0 ? function (node) {
        return node.data.identifiant;
      } : _ref$buildKey,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var forceUpdate = useForceUpdate();
    React.useEffect(function () {
      var listener = function listener(signal) {
        if (['informChildRemoved', 'informChildAdded'].includes(signal)) {
          forceUpdate();
        }
      };
      root.addSignalListener(listener);
      return function () {
        root.removeSignalListener(listener);
      };
    }, [root]);
    return root.propagateToChildren(function (node, acc) {
      return acc.concat(node);
    }, []).map(function (node) {
      return /*#__PURE__*/_jsx(NodeComponent, Object.assign({}, rest, {
        node: node,
        buildKey: buildKey,
        children: children
      }));
    });
  };
};
TreeBuilder.handledProps = [];
export default TreeBuilder;